import { Pipe, PipeTransform, NgModule } from '@angular/core';
//https://stackoverflow.com/questions/49432789/angular-translate-using-replace-in-an-interpolation-string-in-html?rq=1

@Pipe({
  name: 'titleReplace'
})
export class TitlePipe implements PipeTransform {

  transform(title: string): any {
    //https://stackoverflow.com/questions/9823718/replace-forward-slash-character-in-javascript-string
    //https://stackoverflow.com/questions/15604140/replace-multiple-strings-with-multiple-other-strings
    //console.log(title.replace(/\//g, '').replace(/<b>/gi, '').replace(/<br>/gi, ' '))
    return title.replace(/\//g, '').replace(/<b>/gi, '').replace(/<br>/gi, ' ');
  }
}

@NgModule({
  declarations: [TitlePipe],
  exports: [TitlePipe],
})
export class TitlePipeModule {}
